
class exports.Maps extends KoModel

    constructor: (handler) ->
        super()
        @handler = handler

        @is_new = ko.observable true
        @is_upload = ko.observable false
        @is_download = ko.observable false
        @is_draw = ko.observable false


    startUpload: () ->
        @is_new false
        @is_upload true
        @is_download false


    startDownload: () ->
        @is_new false
        @is_upload false
        @is_download true


    startDraw: () ->
        @is_new true
        @is_upload false
        @is_download false
        @is_draw true


    reset: () ->
        @is_new true
        @is_upload false
        @is_download false
        @is_draw false


    launchDrawHandler: () ->
        DrawHandler = @handler.parent.createSubHandler("grower::handlers/data/Data_Maps_Draw_Handler")
        if DrawHandler
            DrawHandler.init()


